import React from 'react';
import {
  Layout,
} from 'antd';
import { Box, Text } from '../../shared/components';

const { Header: HeaderComponent } = Layout;


export default function Header({
  actionButtons, title, navigationButton, overrideContent,
}) {
  return (
    <HeaderComponent
      id="qc-app-header"
    >
      { overrideContent || (
      <>
        <Box flex={1} pl={6} textAlign="left">
          { navigationButton }
        </Box>

        <Box flex={3} textAlign="center">
          <Text fontWeight="bold">
            {title}
          </Text>
        </Box>

        <Box flex={1} pr={6} textAlign="right">
          { actionButtons }
        </Box>

      </>
      )}

    </HeaderComponent>
  );
}
